import * as React from "react"
import { useEffect } from "react"
import { useComputed } from "@preact/signals-react"
import { number, object } from "yup"
import { useValidatorSeeker } from "@ui-seeker/app"

import { DIPBrandCustomer } from "@components"
import { BACKEND_APIS } from "@constants"
import { useAdminSkuForm } from "../../@hooks"
import { adminSkuFormData, adminSkuFormErrors } from "../../@signals"


export default function AdminSkuFormBrand() {
    const category = useComputed(() => adminSkuFormData.value.category)

    const { localValue, handleChange } = useAdminSkuForm("brand")

    const { errors } = useValidatorSeeker({
        brand: localValue
    }, object({
        brand: number().required("Brand is mandatory")
    }))

    useEffect(() => {
        adminSkuFormErrors.value = {
            ...adminSkuFormErrors.value,
            brand: errors?.brand
        }
    }, [errors?.brand])

    return <DIPBrandCustomer
        multiple={false}
        urlAjax={`${BACKEND_APIS.MASTER_DATA}/brand/without-customer/find-options`}
        label="Brand SKU"
        placeholder="Please select a brand for the SKU"
        error={errors?.brand}
        value={localValue || ""}
        filters={{
            category: category.value || ""
        }}
        onChange={(e, op) => handleChange(e.target.value, {
            brandName: op.label
        })}
    />
}